import {
    SUPPORTING_DOCUMENT_USER_DELETE_ERROR,
    SUPPORTING_DOCUMENT_USER_DELETE_REQUEST,
    SUPPORTING_DOCUMENT_USER_DELETE_SUCCESS,
    CLEAR_DOCUMENTS_SUPPORTING_USER_DATA,
  } from "../../Types/user/Types";
  
  const initialState = {
    error: "",
    Supporting_document_user_delete_data: "",
    loader: false,
  };
  const SupportingUserDocumentDeleteReducer = (
    state = initialState,
    action
  ) => {
    switch (action.type) {
      case SUPPORTING_DOCUMENT_USER_DELETE_SUCCESS:
        return {
          ...initialState.Supporting_document_user_delete_data,
          error: "",
          Supporting_document_user_delete_data: action.payload,
          loader: false,
        };
      case SUPPORTING_DOCUMENT_USER_DELETE_ERROR:
        return {
          ...initialState.Supporting_document_user_delete_data,
          error: action.error,
          Supporting_document_user_delete_data: "",
          loader: false,
        };
      case SUPPORTING_DOCUMENT_USER_DELETE_REQUEST:
        return {
          ...initialState.Supporting_document_user_delete_data,
          error: null,
          Supporting_document_user_delete_data: "",
          loader: true,
        };
      case CLEAR_DOCUMENTS_SUPPORTING_USER_DATA:
        return {
          ...state,
          Supporting_document_user_delete_data: null,
        };
      default:
        return state;
    }
  };
  export default SupportingUserDocumentDeleteReducer;
  